import { EzwmAccountLoginFault } from '@dreryk/egabinet-ezwm-frontend-api';
import {
   CurrentPractitionerNfzConfigurationQuery,
   PractitionerNfzConfiguration,
} from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { performCqrsQueryFind } from '@dreryk/command-query-react-common';
import { isFaultType } from '@dreryk/command-query-ws-client';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../translations';

export const isNfzMfaLoginFault = (error: unknown): boolean => {
   return isFaultType(error as Error, new EzwmAccountLoginFault().class);
};

export const isEzwmMfaRequired = async (): Promise<boolean> => {
   try {
      const configuration = await performCqrsQueryFind<PractitionerNfzConfiguration>(
         () => new CurrentPractitionerNfzConfigurationQuery()
      );

      return !configuration?.mfaSecretPresent;
   } catch (error) {
      dispatchSnackbarNegativeEvent(nfzLoginTranslationKeys.errorWhileFetchingNfzConfiguration);
      throw error;
   }
};
